import { handleCheckboxField } from 'common/utils/helpers';

import { buildParameters } from './buildParameters';

/**
 * Builder base para construir el payload de productos financieros
 * @param {Object} values - Valores del formulario
 * @param {Object} config - Configuración específica del partner
 * @returns {Object} Payload para enviar al API
 */
export const createPayloadBuilder =
    (config = {}) =>
    (values) => {
        const {
            accesories_list_optional,
            alerts = {},
            amount_values,
            annual_increase = 0,
            catalog_documents,
            description,
            id,
            insurance_product,
            inverters_list = [],
            name,
            panels_list = [],
            power_values,
            rate_list = [],
            template,
            type,
            type_algorithm,
            types_business_company,
        } = values;

        // Procesar listas y valores comunes
        const accesoriesListOptional = handleCheckboxField(
            accesories_list_optional,
        );
        const amountValues = amount_values.min + ',' + amount_values.max;
        const catalogDocuments = handleCheckboxField(catalog_documents);
        const invertersList = inverters_list?.toString();
        const panelsList = panels_list?.toString();
        const powerValues = power_values.min + ',' + power_values.max;
        const rateList = rate_list?.join(',');

        // Construir parámetros usando el builder correspondiente
        const parametersBuilder = config.buildParameters || buildParameters;
        const parameters = parametersBuilder(values);

        // Payload base común a todos los partners
        let basePayload = {
            accesories_list_must_have: '',
            accesories_list_optional: accesoriesListOptional,
            alerts,
            amount_values: amountValues,
            annual_increase,
            catalog_documents: catalogDocuments,
            description,
            insurance_product,
            inverters_list: invertersList,
            name,
            panels_list: panelsList,
            parameters,
            power_values: powerValues,
            rate_list: rateList,
            template,
            type,
            type_algorithm,
            types_business_company,
        };

        // Agregar ID si existe
        if (id) basePayload.id = id;

        // Permitir extensiones del partner para campos adicionales
        if (config.extendPayload) {
            basePayload = config.extendPayload(basePayload, values);
        }

        // Serializar campos complejos
        const finalPayload = {
            ...basePayload,
            alerts: JSON.stringify(basePayload.alerts),
            parameters: JSON.stringify(basePayload.parameters),
        };

        return finalPayload;
    };

/**
 * Builder de payload por defecto sin extensiones
 */
export const buildPayload = createPayloadBuilder();
